import { useTranslation } from "react-i18next";

export default function ContentSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            {t("content.title")}
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
            {t("content.p1")}
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            {t("content.p2")}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="mt-7 inline-flex items-center gap-2 whitespace-nowrap px-6 py-3 rounded-md bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            {t("content.cta")}
          </a>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="rounded-lg overflow-hidden h-48 md:h-56">
            <img
              src="https://readdy.ai/api/search-image?query=A%20cozy%20open%20wardrobe%20rack%20with%20folded%20sweaters%20hanging%20jackets%20and%20a%20pair%20of%20white%20sneakers%20on%20a%20warm%20clay%20wall%20background%2C%20soft%20golden%20hour%20light%2C%20editorial%20fashion%20photography%20with%20rich%20earthy%20tones%20and%20a%20relaxed%20lived%20in%20composition&width=800&height=600&seq=content-img-01&orientation=portrait&nocache=true"
              alt="USFans Spreadsheet wardrobe"
              title="USFans Spreadsheet clothing"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="rounded-lg overflow-hidden h-48 md:h-56 mt-6">
            <img
              src="https://readdy.ai/api/search-image?query=A%20curated%20shelf%20styled%20with%20a%20woven%20basket%20a%20leather%20handbag%20a%20folded%20scarf%20and%20a%20ceramic%20vase%20on%20a%20soft%20olive%20wall%20background%2C%20warm%20natural%20light%2C%20editorial%20interior%20product%20photography%20with%20gentle%20shadows%20and%20a%20balanced%20composition&width=800&height=600&seq=content-img-02&orientation=portrait&nocache=true"
              alt="USFans Spreadsheet accessories"
              title="USFans Spreadsheet bags and belts"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}